export const LOAN_ROUTER_V2_ABI = [
  {
    type: "function",
    name: "collateralTimelock",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "deadlines",
    inputs: [
      {
        name: "loanTerms",
        type: "tuple",
        internalType: "struct ILoanRouterV2.LoanTermsV2",
        components: [
          {
            name: "expiration",
            type: "uint64",
            internalType: "uint64",
          },
          {
            name: "borrower",
            type: "address",
            internalType: "address",
          },
          {
            name: "currencyToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "repaymentSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.RepaymentSpec",
            components: [
              {
                name: "totalDurationDays",
                type: "uint16",
                internalType: "uint16",
              },
              { name: "day", type: "uint8", internalType: "uint8" },
              {
                name: "timezoneOffsetSeconds",
                type: "int32",
                internalType: "int32",
              },
            ],
          },
          {
            name: "interestRateSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.InterestRateSpec",
            components: [
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "collateralTokenIds",
            type: "uint256[]",
            internalType: "uint256[]",
          },
          {
            name: "trancheSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.TrancheSpec[]",
            components: [
              {
                name: "lender",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              { name: "rate", type: "uint256", internalType: "uint256" },
            ],
          },
          {
            name: "feeSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.FeeSpec[]",
            components: [
              {
                name: "kind",
                type: "uint8",
                internalType: "enum ILoanRouterV2.FeeKind",
              },
              {
                name: "recipient",
                type: "address",
                internalType: "address",
              },
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "approvalAddresses",
            type: "address[]",
            internalType: "address[]",
          },
          { name: "options", type: "bytes", internalType: "bytes" },
        ],
      },
    ],
    outputs: [{ name: "", type: "uint64[]", internalType: "uint64[]" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "depositLiquidationProceeds",
    inputs: [
      {
        name: "loanTerms",
        type: "tuple",
        internalType: "struct ILoanRouterV2.LoanTermsV2",
        components: [
          {
            name: "expiration",
            type: "uint64",
            internalType: "uint64",
          },
          {
            name: "borrower",
            type: "address",
            internalType: "address",
          },
          {
            name: "currencyToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "repaymentSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.RepaymentSpec",
            components: [
              {
                name: "totalDurationDays",
                type: "uint16",
                internalType: "uint16",
              },
              { name: "day", type: "uint8", internalType: "uint8" },
              {
                name: "timezoneOffsetSeconds",
                type: "int32",
                internalType: "int32",
              },
            ],
          },
          {
            name: "interestRateSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.InterestRateSpec",
            components: [
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "collateralTokenIds",
            type: "uint256[]",
            internalType: "uint256[]",
          },
          {
            name: "trancheSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.TrancheSpec[]",
            components: [
              {
                name: "lender",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              { name: "rate", type: "uint256", internalType: "uint256" },
            ],
          },
          {
            name: "feeSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.FeeSpec[]",
            components: [
              {
                name: "kind",
                type: "uint8",
                internalType: "enum ILoanRouterV2.FeeKind",
              },
              {
                name: "recipient",
                type: "address",
                internalType: "address",
              },
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "approvalAddresses",
            type: "address[]",
            internalType: "address[]",
          },
          { name: "options", type: "bytes", internalType: "bytes" },
        ],
      },
      { name: "proceeds", type: "uint256", internalType: "uint256" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "depositTimelock",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "escrowTimelock",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "feeRecipient",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "lenderPositionInfo",
    inputs: [{ name: "tokenId", type: "uint256", internalType: "uint256" }],
    outputs: [
      {
        name: "loanTermsHash_",
        type: "bytes32",
        internalType: "bytes32",
      },
      { name: "trancheIndex", type: "uint8", internalType: "uint8" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "liquidate",
    inputs: [
      {
        name: "loanTerms",
        type: "tuple",
        internalType: "struct ILoanRouterV2.LoanTermsV2",
        components: [
          {
            name: "expiration",
            type: "uint64",
            internalType: "uint64",
          },
          {
            name: "borrower",
            type: "address",
            internalType: "address",
          },
          {
            name: "currencyToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "repaymentSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.RepaymentSpec",
            components: [
              {
                name: "totalDurationDays",
                type: "uint16",
                internalType: "uint16",
              },
              { name: "day", type: "uint8", internalType: "uint8" },
              {
                name: "timezoneOffsetSeconds",
                type: "int32",
                internalType: "int32",
              },
            ],
          },
          {
            name: "interestRateSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.InterestRateSpec",
            components: [
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "collateralTokenIds",
            type: "uint256[]",
            internalType: "uint256[]",
          },
          {
            name: "trancheSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.TrancheSpec[]",
            components: [
              {
                name: "lender",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              { name: "rate", type: "uint256", internalType: "uint256" },
            ],
          },
          {
            name: "feeSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.FeeSpec[]",
            components: [
              {
                name: "kind",
                type: "uint8",
                internalType: "enum ILoanRouterV2.FeeKind",
              },
              {
                name: "recipient",
                type: "address",
                internalType: "address",
              },
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "approvalAddresses",
            type: "address[]",
            internalType: "address[]",
          },
          { name: "options", type: "bytes", internalType: "bytes" },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "loanState",
    inputs: [
      {
        name: "loanTermsHash_",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [
      {
        name: "status",
        type: "uint8",
        internalType: "enum ILoanRouterV2.LoanStatus",
      },
      {
        name: "repaymentCount",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "originationTimestamp",
        type: "uint64",
        internalType: "uint64",
      },
      {
        name: "scaledBalance",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "loanState",
    inputs: [{ name: "tokenId", type: "uint256", internalType: "uint256" }],
    outputs: [
      {
        name: "status",
        type: "uint8",
        internalType: "enum ILoanRouterV2.LoanStatus",
      },
      {
        name: "repaymentCount",
        type: "uint16",
        internalType: "uint16",
      },
      {
        name: "originationTimestamp",
        type: "uint64",
        internalType: "uint64",
      },
      {
        name: "scaledBalance",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "loanTermsHash",
    inputs: [
      {
        name: "loanTerms",
        type: "tuple",
        internalType: "struct ILoanRouterV2.LoanTermsV2",
        components: [
          {
            name: "expiration",
            type: "uint64",
            internalType: "uint64",
          },
          {
            name: "borrower",
            type: "address",
            internalType: "address",
          },
          {
            name: "currencyToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "repaymentSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.RepaymentSpec",
            components: [
              {
                name: "totalDurationDays",
                type: "uint16",
                internalType: "uint16",
              },
              { name: "day", type: "uint8", internalType: "uint8" },
              {
                name: "timezoneOffsetSeconds",
                type: "int32",
                internalType: "int32",
              },
            ],
          },
          {
            name: "interestRateSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.InterestRateSpec",
            components: [
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "collateralTokenIds",
            type: "uint256[]",
            internalType: "uint256[]",
          },
          {
            name: "trancheSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.TrancheSpec[]",
            components: [
              {
                name: "lender",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              { name: "rate", type: "uint256", internalType: "uint256" },
            ],
          },
          {
            name: "feeSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.FeeSpec[]",
            components: [
              {
                name: "kind",
                type: "uint8",
                internalType: "enum ILoanRouterV2.FeeKind",
              },
              {
                name: "recipient",
                type: "address",
                internalType: "address",
              },
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "approvalAddresses",
            type: "address[]",
            internalType: "address[]",
          },
          { name: "options", type: "bytes", internalType: "bytes" },
        ],
      },
    ],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "loanTokenIds",
    inputs: [
      {
        name: "loanTerms",
        type: "tuple",
        internalType: "struct ILoanRouterV2.LoanTermsV2",
        components: [
          {
            name: "expiration",
            type: "uint64",
            internalType: "uint64",
          },
          {
            name: "borrower",
            type: "address",
            internalType: "address",
          },
          {
            name: "currencyToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "repaymentSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.RepaymentSpec",
            components: [
              {
                name: "totalDurationDays",
                type: "uint16",
                internalType: "uint16",
              },
              { name: "day", type: "uint8", internalType: "uint8" },
              {
                name: "timezoneOffsetSeconds",
                type: "int32",
                internalType: "int32",
              },
            ],
          },
          {
            name: "interestRateSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.InterestRateSpec",
            components: [
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "collateralTokenIds",
            type: "uint256[]",
            internalType: "uint256[]",
          },
          {
            name: "trancheSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.TrancheSpec[]",
            components: [
              {
                name: "lender",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              { name: "rate", type: "uint256", internalType: "uint256" },
            ],
          },
          {
            name: "feeSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.FeeSpec[]",
            components: [
              {
                name: "kind",
                type: "uint8",
                internalType: "enum ILoanRouterV2.FeeKind",
              },
              {
                name: "recipient",
                type: "address",
                internalType: "address",
              },
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "approvalAddresses",
            type: "address[]",
            internalType: "address[]",
          },
          { name: "options", type: "bytes", internalType: "bytes" },
        ],
      },
    ],
    outputs: [{ name: "", type: "uint256[]", internalType: "uint256[]" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "migrateLoan",
    inputs: [
      {
        name: "loanTermsV1",
        type: "tuple",
        internalType: "struct ILoanRouterV1.LoanTerms",
        components: [
          {
            name: "expiration",
            type: "uint64",
            internalType: "uint64",
          },
          {
            name: "borrower",
            type: "address",
            internalType: "address",
          },
          {
            name: "currencyToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "collateralTokenId",
            type: "uint256",
            internalType: "uint256",
          },
          { name: "duration", type: "uint64", internalType: "uint64" },
          {
            name: "repaymentInterval",
            type: "uint64",
            internalType: "uint64",
          },
          {
            name: "interestRateModel",
            type: "address",
            internalType: "address",
          },
          {
            name: "gracePeriodRate",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "gracePeriodDuration",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "feeSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV1.FeeSpec",
            components: [
              {
                name: "originationFee",
                type: "uint256",
                internalType: "uint256",
              },
              {
                name: "exitFee",
                type: "uint256",
                internalType: "uint256",
              },
            ],
          },
          {
            name: "trancheSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV1.TrancheSpec[]",
            components: [
              {
                name: "lender",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              { name: "rate", type: "uint256", internalType: "uint256" },
            ],
          },
          {
            name: "collateralWrapperContext",
            type: "bytes",
            internalType: "bytes",
          },
          { name: "options", type: "bytes", internalType: "bytes" },
        ],
      },
      {
        name: "loanTermsV2",
        type: "tuple",
        internalType: "struct ILoanRouterV2.LoanTermsV2",
        components: [
          {
            name: "expiration",
            type: "uint64",
            internalType: "uint64",
          },
          {
            name: "borrower",
            type: "address",
            internalType: "address",
          },
          {
            name: "currencyToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "repaymentSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.RepaymentSpec",
            components: [
              {
                name: "totalDurationDays",
                type: "uint16",
                internalType: "uint16",
              },
              { name: "day", type: "uint8", internalType: "uint8" },
              {
                name: "timezoneOffsetSeconds",
                type: "int32",
                internalType: "int32",
              },
            ],
          },
          {
            name: "interestRateSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.InterestRateSpec",
            components: [
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "collateralTokenIds",
            type: "uint256[]",
            internalType: "uint256[]",
          },
          {
            name: "trancheSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.TrancheSpec[]",
            components: [
              {
                name: "lender",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              { name: "rate", type: "uint256", internalType: "uint256" },
            ],
          },
          {
            name: "feeSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.FeeSpec[]",
            components: [
              {
                name: "kind",
                type: "uint8",
                internalType: "enum ILoanRouterV2.FeeKind",
              },
              {
                name: "recipient",
                type: "address",
                internalType: "address",
              },
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "approvalAddresses",
            type: "address[]",
            internalType: "address[]",
          },
          { name: "options", type: "bytes", internalType: "bytes" },
        ],
      },
      {
        name: "originationTimestampV2",
        type: "uint64",
        internalType: "uint64",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "originate",
    inputs: [
      {
        name: "loanTerms",
        type: "tuple",
        internalType: "struct ILoanRouterV2.LoanTermsV2",
        components: [
          {
            name: "expiration",
            type: "uint64",
            internalType: "uint64",
          },
          {
            name: "borrower",
            type: "address",
            internalType: "address",
          },
          {
            name: "currencyToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "repaymentSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.RepaymentSpec",
            components: [
              {
                name: "totalDurationDays",
                type: "uint16",
                internalType: "uint16",
              },
              { name: "day", type: "uint8", internalType: "uint8" },
              {
                name: "timezoneOffsetSeconds",
                type: "int32",
                internalType: "int32",
              },
            ],
          },
          {
            name: "interestRateSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.InterestRateSpec",
            components: [
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "collateralTokenIds",
            type: "uint256[]",
            internalType: "uint256[]",
          },
          {
            name: "trancheSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.TrancheSpec[]",
            components: [
              {
                name: "lender",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              { name: "rate", type: "uint256", internalType: "uint256" },
            ],
          },
          {
            name: "feeSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.FeeSpec[]",
            components: [
              {
                name: "kind",
                type: "uint8",
                internalType: "enum ILoanRouterV2.FeeKind",
              },
              {
                name: "recipient",
                type: "address",
                internalType: "address",
              },
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "approvalAddresses",
            type: "address[]",
            internalType: "address[]",
          },
          { name: "options", type: "bytes", internalType: "bytes" },
        ],
      },
      {
        name: "lenderDepositInfos",
        type: "tuple[]",
        internalType: "struct ILoanRouterV2.LenderDepositInfo[]",
        components: [
          {
            name: "depositType",
            type: "uint8",
            internalType: "enum ILoanRouterV2.DepositType",
          },
          { name: "data", type: "bytes", internalType: "bytes" },
        ],
      },
      {
        name: "approvalSignatures",
        type: "bytes[]",
        internalType: "bytes[]",
      },
    ],
    outputs: [{ name: "amount", type: "uint256", internalType: "uint256" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "pause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "quote",
    inputs: [
      {
        name: "loanTerms",
        type: "tuple",
        internalType: "struct ILoanRouterV2.LoanTermsV2",
        components: [
          {
            name: "expiration",
            type: "uint64",
            internalType: "uint64",
          },
          {
            name: "borrower",
            type: "address",
            internalType: "address",
          },
          {
            name: "currencyToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "repaymentSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.RepaymentSpec",
            components: [
              {
                name: "totalDurationDays",
                type: "uint16",
                internalType: "uint16",
              },
              { name: "day", type: "uint8", internalType: "uint8" },
              {
                name: "timezoneOffsetSeconds",
                type: "int32",
                internalType: "int32",
              },
            ],
          },
          {
            name: "interestRateSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.InterestRateSpec",
            components: [
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "collateralTokenIds",
            type: "uint256[]",
            internalType: "uint256[]",
          },
          {
            name: "trancheSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.TrancheSpec[]",
            components: [
              {
                name: "lender",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              { name: "rate", type: "uint256", internalType: "uint256" },
            ],
          },
          {
            name: "feeSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.FeeSpec[]",
            components: [
              {
                name: "kind",
                type: "uint8",
                internalType: "enum ILoanRouterV2.FeeKind",
              },
              {
                name: "recipient",
                type: "address",
                internalType: "address",
              },
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "approvalAddresses",
            type: "address[]",
            internalType: "address[]",
          },
          { name: "options", type: "bytes", internalType: "bytes" },
        ],
      },
      { name: "timestamp", type: "uint64", internalType: "uint64" },
    ],
    outputs: [
      {
        name: "principalPayment",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "interestPayment",
        type: "uint256",
        internalType: "uint256",
      },
      { name: "feePayment", type: "uint256", internalType: "uint256" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "repay",
    inputs: [
      {
        name: "loanTerms",
        type: "tuple",
        internalType: "struct ILoanRouterV2.LoanTermsV2",
        components: [
          {
            name: "expiration",
            type: "uint64",
            internalType: "uint64",
          },
          {
            name: "borrower",
            type: "address",
            internalType: "address",
          },
          {
            name: "currencyToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "repaymentSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.RepaymentSpec",
            components: [
              {
                name: "totalDurationDays",
                type: "uint16",
                internalType: "uint16",
              },
              { name: "day", type: "uint8", internalType: "uint8" },
              {
                name: "timezoneOffsetSeconds",
                type: "int32",
                internalType: "int32",
              },
            ],
          },
          {
            name: "interestRateSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.InterestRateSpec",
            components: [
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "collateralTokenIds",
            type: "uint256[]",
            internalType: "uint256[]",
          },
          {
            name: "trancheSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.TrancheSpec[]",
            components: [
              {
                name: "lender",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              { name: "rate", type: "uint256", internalType: "uint256" },
            ],
          },
          {
            name: "feeSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.FeeSpec[]",
            components: [
              {
                name: "kind",
                type: "uint8",
                internalType: "enum ILoanRouterV2.FeeKind",
              },
              {
                name: "recipient",
                type: "address",
                internalType: "address",
              },
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "approvalAddresses",
            type: "address[]",
            internalType: "address[]",
          },
          { name: "options", type: "bytes", internalType: "bytes" },
        ],
      },
      { name: "amount", type: "uint256", internalType: "uint256" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "rescueERC20",
    inputs: [
      { name: "token", type: "address", internalType: "address" },
      { name: "to", type: "address", internalType: "address" },
      { name: "amount", type: "uint256", internalType: "uint256" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setLoanBreach",
    inputs: [
      {
        name: "loanTermsHash_",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "unpause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    name: "ERC20Rescued",
    inputs: [
      {
        name: "token",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "to",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "FeePaid",
    inputs: [
      {
        name: "loanTermsHash",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "kind",
        type: "uint8",
        indexed: true,
        internalType: "enum ILoanRouterV2.FeeKind",
      },
      {
        name: "recipient",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "feeModel",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "HookFailed",
    inputs: [
      {
        name: "reason",
        type: "string",
        indexed: false,
        internalType: "string",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LenderLiquidationRepaid",
    inputs: [
      {
        name: "loanTermsHash",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "lender",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "trancheIndex",
        type: "uint8",
        indexed: true,
        internalType: "uint8",
      },
      {
        name: "principal",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "interest",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LenderPositionMinted",
    inputs: [
      {
        name: "loanTermsHash",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "lender",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "trancheIndex",
        type: "uint8",
        indexed: true,
        internalType: "uint8",
      },
      {
        name: "tokenId",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LenderRepaid",
    inputs: [
      {
        name: "loanTermsHash",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "lender",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "trancheIndex",
        type: "uint8",
        indexed: true,
        internalType: "uint8",
      },
      {
        name: "principal",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "interest",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "prepay",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LiquidationProceedsDeposited",
    inputs: [
      {
        name: "loanTermsHash",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "proceeds",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "fee",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "surplus",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LoanBreached",
    inputs: [
      {
        name: "loanTermsHash",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LoanLiquidated",
    inputs: [
      {
        name: "loanTermsHash",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LoanMigrated",
    inputs: [
      {
        name: "loanTermsHashV1",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "loanTermsHashV2",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "loanTerms",
        type: "bytes",
        indexed: false,
        internalType: "bytes",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LoanOriginated",
    inputs: [
      {
        name: "loanTermsHash",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "borrower",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "currencyToken",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "principal",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "originationFee",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "LoanRepaid",
    inputs: [
      {
        name: "loanTermsHash",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "borrower",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "principal",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "interest",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "prepayment",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "fee",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "isRepaid",
        type: "bool",
        indexed: false,
        internalType: "bool",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "TransferFailed",
    inputs: [
      {
        name: "token",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "recipient",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "intendedRecipient",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  { type: "error", name: "InvalidAddress", inputs: [] },
  { type: "error", name: "InvalidAmount", inputs: [] },
  { type: "error", name: "InvalidCaller", inputs: [] },
  { type: "error", name: "InvalidDepositType", inputs: [] },
  { type: "error", name: "InvalidLength", inputs: [] },
  { type: "error", name: "InvalidLoanState", inputs: [] },
  {
    type: "error",
    name: "InvalidLoanTerms",
    inputs: [{ name: "reason", type: "string", internalType: "string" }],
  },
  { type: "error", name: "InvalidSignature", inputs: [] },
] as const;
